<div class="layout small-gap">
    <div class="section-header no-border layout_one_up_center">
        <span>Welcome, {{ profile.displayName }}</span>
    </div>
    <div class="layout_one_up_center text-gap">
        <span class="text-content text-content-body">
            Welcome to the USAN Application Portal. View and sort applications assigned to you. Click on an application to review details, modify applications, add comments or update the status in Service Now.
        </span>
    </div>
    
    <div *ngIf="!isLoadingComplete" class="spinner-div gbl-div">
        <mat-spinner class="spinner-cls gbl-cls"></mat-spinner>
    </div>
    <div class="full-width">
        <mat-tab-group animationDuration="0ms" (selectedTabChange)="selectedTabChangeApp($event)">
            <mat-tab *ngFor="let appType of appTypes">
                <ng-template mat-tab-label>
                    <span class="app-section-title">{{appType}}</span>
                </ng-template>
                <ng-template matTabContent>
        
                    <div *ngIf="!isSmallView && isShowingResults" class="app-table-cls">
                        <table mat-table [dataSource]="dataSource" #negotiatorSort matSort (matSortChange)="sortChangeUpdate($event)">
                            <caption>
                                <mat-paginator *ngIf="showResults" #paginator [length]="appListLength" [pageSizeOptions]="[5, 10, 20]" 
                                    [pageSize]="pageCardSize" showFirstLastButtons aria-label="Select page of Applications"
                                    (page)="onPageChange($event)">
                                </mat-paginator>
                            </caption>
                            <ng-container matColumnDef="fileNumber">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by File Number"> File Number </th>
                                <td mat-cell *matCellDef="let element"><span class="text-body">{{ element.fileNumber }}</span></td>
                            </ng-container>
                        
                            <ng-container matColumnDef="form">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Form Type"> Form </th>
                                <td mat-cell *matCellDef="let element">
                                    <div class="form-element-outer"><span class="form-element-span text-body">{{ element.form }}</span></div> 
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="submittedDate">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Date"> Submitted </th>
                                <td mat-cell *matCellDef="let element"><span class="text-body">{{element.submittedDate | date: 'MM/dd/yyyy'}}</span></td>
                            </ng-container>

                            <ng-container matColumnDef="firstSuggestedName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Suggested Name"> Suggested Name </th>
                                <td mat-cell *matCellDef="let element"><span class="text-body">{{ element.firstSuggestedName }}</span></td> 
                            </ng-container>

                            <ng-container matColumnDef="contactName">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Contact Name"> Contact Name </th>
                                <td mat-cell *matCellDef="let element"><span class="text-body">{{ element.contactName }}</span></td> 
                            </ng-container>

                            <ng-container matColumnDef="company">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Company"> Company </th>
                                <td mat-cell *matCellDef="let element"><span class="text-body">{{ element.company }}</span></td> 
                            </ng-container>

                            <ng-container matColumnDef="contactEmail">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Email"> Contact Email </th>
                                <td mat-cell *matCellDef="let element"><span class="text-body">{{ element.contactEmail }}</span></td> 
                            </ng-container>

                            <ng-container matColumnDef="status">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Email"> Status </th>
                                <td mat-cell *matCellDef="let element"><span class="text-body">{{ element.status }}</span></td> 
                            </ng-container>

                            <ng-container matColumnDef="viewApplication">
                                <th mat-header-cell *matHeaderCellDef> View </th>
                                <td mat-cell *matCellDef="let element">
                                    <button mat-icon-button aria-label="View icon" (click)="viewApplication(element)">
                                        <mat-icon>visibility</mat-icon>
                                    </button>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
                        </table>
                    </div>

                    <div *ngIf="isSmallView && isShowingResults" class="full-width">
                        <mat-paginator #cardPaginator [pageSizeOptions]="[5, 10, 20]" 
                            [length]="appListLength"  [pageSize]="pageCardSize" (page)="onPageChange($event)">
                        </mat-paginator>
                        <mat-card class="application-card" *ngFor="let app of appCardDataPag" class="mat-mdc-card mdc-card application-card"> <!-- dataSource.data-->
                            <mat-card-content class="application-card-content">
                                <div class="full-width">
                                    <div class="card-main-section-left">
                                        <div class="card-form-name">{{formTypeMap[app.form]}}</div>
                                        <div class="card-sugg-name">{{app.firstSuggestedName}}</div>
                                    </div>
                                    <div class="float-right">
                                        <button class="card-icon-cls" mat-icon-button [matMenuTriggerFor]="applicationMenu" aria-label="View icon" 
                                        (click)="viewApplication(app)"> 
                                            <mat-icon class="details-cls">visibility</mat-icon>
                                        </button>
                                    </div>
                                </div>
                                <div class="full-width"></div>
                                <table class="full-width">
                                    <tr>
                                        <td class="card-section-bottom-item">
                                            <div >
                                                <label class="card-bottom-item-title">Contact</label>
                                                <label class="card-bottom-item-value">{{shorten(app.contactName)}}</label>
                                            </div>
                                        </td>
                                        <td class="card-section-bottom-item padding-left-10">
                                            <div >
                                                <label class="card-bottom-item-title">Company</label>
                                                <label class="card-bottom-item-value ellipsis-text">{{app.company}}</label>
                                            </div>
                                        </td>
                                        <td class="card-section-bottom-last-item">
                                            <div >
                                                <label class="card-bottom-item-title">Date</label>
                                                <label class="card-bottom-item-value">{{app.submittedDate | date: 'MM/dd/yyyy'}}</label>
                                            </div>
                                        </td>
                                    </tr>
                                </table>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </ng-template>
            </mat-tab>
        </mat-tab-group>
    </div>
</div>